import { render, staticRenderFns } from "./medicina-ocupacional-editar.vue?vue&type=template&id=4feba536&"
import script from "./medicina-ocupacional-editar.vue?vue&type=script&lang=js&"
export * from "./medicina-ocupacional-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports